module.exports = __webpack_public_path__ + "static/media/MinionPro-Regular.2b3e7f4c.woff";